<ng-container *ngIf="tertiaryButtons.length > 0">
  <button mat-icon-button color="primary" [matMenuTriggerFor]="tertiary">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #tertiary="matMenu">
    <ng-container *ngFor="let button of tertiaryButtons">
      <a
        mat-menu-item
        matTooltip="{{ button.tooltip | translate }}"
        [id]="button.buttonId"
        [routerLink]="button.url"
        [target]="button.openNewTab ? '_blank' : '_self'"
        [ngClass]="button.cssClasses"
        (click)="clicked(button)"
      >
        <ng-container *ngIf="button.icon">
          <mat-icon>{{ button.icon }}</mat-icon>
        </ng-container>
        <span class="menu-title">{{ button.title | translate }}</span>
      </a>
    </ng-container>
  </mat-menu>
</ng-container>
